import Box from '@mui/material/Box';
import { CustomerDetail } from '../../../../features/users/views/CustomerDetailsTable';
import OpenWindow from '../../../components/OpenWindow/OpenWindow';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import TestEmailButton from './TestEmailButton';

type EmailSettingsProps = {
    data: CustomerDetail;
    onChange: (updatedValue: CustomerDetail) => void;
};

const SmtpSettings = (props: EmailSettingsProps) => {
    const { data, onChange } = props;

    const onUpdateString = async (prop: string, value: string) => {
        const temp = structuredClone(data);
        temp[prop] = value;
        onChange(temp);
    };

    return (
        <>
            <TextField
                error={data.emailAddressError}
                fullWidth
                label="Email Address"
                placeholder="Email Address"
                size="small"
                type="email"
                value={data.emailAddress}
                onChange={(e) => onUpdateString('emailAddress', e.target.value)}
            />

            <TextField
                error={data.emailUserAccountError}
                fullWidth
                label="User Account"
                placeholder="User Account"
                size="small"
                type="text"
                value={data.emailUserAccount}
                onChange={(e) => onUpdateString('emailUserAccount', e.target.value)}
            />

            <TextField
                error={data.smtpPasswordError}
                fullWidth
                label="Password"
                placeholder="Password"
                size="small"
                type="password"
                value={data.smtpPassword}
                onChange={(e) => onUpdateString('smtpPassword', e.target.value)}
            />

            <TextField
                error={data.smtpOutgoingHostError}
                fullWidth
                label="Host"
                placeholder="Host"
                size="small"
                type="text"
                value={data.smtpOutgoingHost}
                onChange={(e) => onUpdateString('smtpOutgoingHost', e.target.value)}
            />

            <TextField
                error={data.smtpOutgoingPortError}
                fullWidth
                label="Port"
                placeholder="Port"
                size="small"
                type="number"
                value={data.smtpOutgoingPort}
                onChange={(e) => onUpdateString('smtpOutgoingPort', e.target.value)}
            />

            <TestEmailButton data={data} onUpdate={(updatedData: CustomerDetail) => onChange(updatedData)} />
        </>
    );
};

export default SmtpSettings;
